export const userStoryTableColumns = [
  {
    key : "row-select",
    display_name : "",
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
    cellStyles: {
      width: 0,
    },
    headerStyles: {
      background : "#7593F2",
      color: "#FFFFFF",
      width : "4%",
      "font-weight": 600
    }
  },
  {
    display_name: "Story ID",
    key: "key",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      width: "8%",
      "font-weight": 600,
    },
  },
  {
    display_name: "Story",
    key: "storysummary",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
    },
  },
  {
    display_name: "Story Description",
    key: "storydesc",
    headerStyles: {
      width: "30%",
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
    },
  },
  {
    display_name: "Acceptance Criteria",
    key: "acceptancecriteria",
    headerStyles: {
      width: "40%",
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
    },
  },
];


export const userStoryConfirmationTableColumns = [
  {
    display_name: "Story ID",
    key: "storyId",
    headerStyles: {
      borderRadius: "6px 0 0",
      background: "#7593F2",
      color: "#FFFFFF",
      width: "8%",
      "font-weight": 600,
    },
  },
  {
    display_name: "Story",
    key: "summary",
    headerStyles: {
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
    },
  },
  {
    display_name: "Story Description",
    key: "description",
    headerStyles: {
      width: "30%",
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
    },
  },
  {
    display_name: "Acceptance Criteria",
    key: "acceptanceCriteria",
    headerStyles: {
      borderRadius: "0 6px 0 0",
      width: "40%",
      background: "#7593F2",
      color: "#FFFFFF",
      "font-weight": 600,
    },
  },
];
